import TextArea from '@atlaskit/textarea';
import { token } from '@atlaskit/tokens';
import React, { useLayoutEffect, useRef } from 'react';

const EDIT_FIELD_DESCRIPTION_MAX_LENGTH = 350;

const descriptionInputStyle: React.CSSProperties = {
  width: '100%',
  boxSizing: 'border-box',
  borderRadius: token('radius.medium', '6px'),
  maxHeight: '50vh',
  overflowY: 'auto'
};

type EditFieldDescriptionInputProps = {
  ariaLabel: string;
  autoFocus: boolean;
  onBlur: () => void;
  onChange: (event: React.ChangeEvent<HTMLTextAreaElement>) => void;
  onKeyDown: (event: React.KeyboardEvent<HTMLTextAreaElement>) => void;
  placeholder: string;
  value: string;
};

export function EditFieldDescriptionInput({
  ariaLabel,
  autoFocus,
  onBlur,
  onChange,
  onKeyDown,
  placeholder,
  value
}: EditFieldDescriptionInputProps) {
  const inputRef = useRef<HTMLTextAreaElement>(null);

  useLayoutEffect(() => {
    const input = inputRef.current;
    if (!input) {
      return;
    }

    input.style.height = 'auto';
    const borderHeight = input.offsetHeight - input.clientHeight;
    input.style.height = `${input.scrollHeight + borderHeight}px`;
  }, [value]);

  return (
    <TextArea
      ref={inputRef}
      autoFocus={autoFocus}
      testId="field-menu-description-input"
      value={value}
      maxLength={EDIT_FIELD_DESCRIPTION_MAX_LENGTH}
      minimumRows={2}
      resize="none"
      style={descriptionInputStyle}
      aria-label={ariaLabel}
      placeholder={placeholder}
      onChange={onChange}
      onBlur={onBlur}
      onKeyDown={onKeyDown}
    />
  );
}
